import { render, staticRenderFns } from "./consultoria.vue?vue&type=template&id=da0cd24a"
import script from "./consultoria.vue?vue&type=script&lang=js"
export * from "./consultoria.vue?vue&type=script&lang=js"
import style0 from "./consultoria.vue?vue&type=style&index=0&id=da0cd24a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports